
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface NotificationBadgeProps {
  className?: string;
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = ({ className = "" }) => {
  const { user } = useAuth();

  const { data: unreadCount = 0 } = useQuery({
    queryKey: ['notification_count', user?.id],
    queryFn: async () => {
      if (!user) return 0;

      try {
        const { count, error } = await supabase
          .from('notifications')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id)
          .eq('is_for_user', true)
          .eq('is_read', false)
          .eq('is_archived', false);

        if (error) throw error;

        return count || 0;
      } catch (error) {
        console.error('Error fetching unread notifications count:', error);
        return 0;
      }
    },
    enabled: !!user?.id,
    refetchInterval: 60000 // Refresh every minute
  });

  if (!unreadCount) return null;

  return (
    <span className={`absolute ${className || 'top-0 right-0'} flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white`}>
      {unreadCount > 9 ? '9+' : unreadCount}
    </span>
  );
};
